import React from "react";
import { motion } from "framer-motion";
import { Smartphone, Camera, Gavel, Truck, CreditCard } from "lucide-react";
import ProcessStep from "./seller/ProcessStep";
import SellerBenefits from "./seller/SellerBenefits";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const SellerJourneySection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData = labels.menuPages?.howItWorks?.sellerJourneySection || {};
  const stepsData = sectionData.steps || [];

  const icons = [
    <Smartphone className="w-6 h-6 md:w-8 md:h-8 text-emerald-500" />,
    <Camera className="w-6 h-6 md:w-8 md:h-8 text-blue-500" />,
    <Gavel className="w-6 h-6 md:w-8 md:h-8 text-purple-500" />,
    <Truck className="w-6 h-6 md:w-8 md:h-8 text-orange-500" />,
    <CreditCard className="w-6 h-6 md:w-8 md:h-8 text-green-500" />,
  ];

  const steps = stepsData.map((step: any, index: number) => ({
    icon: icons[index] || icons[0],
    title: step.title || "",
    description: step.description || "",
    details: step.details || "",
  }));

  return (
    <section className="py-12 md:py-16 bg-gradient-to-b from-gray-50 to-emerald-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-8 md:mb-12"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            {sectionData.title || "För Dig Som Vill Sälja"}
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed px-2">
            {sectionData.description ||
              "Från registrering till betalning - vi gör bilförsäljning enkelt, säkert och lönsamt."}
          </p>
        </motion.div>

        <div className="max-w-3xl mx-auto">
          {steps.map((step, index) => (
            <ProcessStep
              key={index}
              step={step}
              index={index}
              isReversed={index % 2 === 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default SellerJourneySection;
